exports.stripTags = (string = '') => string.replace(/(<([^>]+)>)/gi, '');
